import { dashboardService } from '../../queries/dashboard';
import useUserMemory from '../use-user-memory';
import { useEffect, useState } from 'react';

const useRadialStatus = () => {
  const { memoryUserUuid } = useUserMemory();
  const [data, setData] = useState<
    {
      label: 'NEW' | 'LEARNING' | 'SCHEDULED';
      value: number;
      percentage: number;
      color: string;
    }[]
  >([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!memoryUserUuid) return;
      const data = await dashboardService.getRadialStatusChart(memoryUserUuid);
      setData(data);
    };
    fetchData();
  }, [memoryUserUuid]);

  return { data };
};

export default useRadialStatus;
